import { TabFallback } from '@/components/TabFallback';
import { Suspense, lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import type { RouteHandle } from './types';

// Lazy-load the page module so `/me` doesn't bloat the initial bundle —
// matches the convention established by `admin.routes.tsx`.
const UserProfile = lazy(() =>
  import('@/pages/UserProfile').then((m) => ({ default: m.UserProfile })),
);

const handle: RouteHandle = {
  crumb: 'Profile',
  requiredPermissions: [],
};

export const meRoutes: RouteObject[] = [
  {
    path: 'me',
    element: (
      <Suspense fallback={<TabFallback />}>
        <UserProfile />
      </Suspense>
    ),
    handle,
  },
];
